import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(constants.GET_LIST_TRANSACTION_FILE.REQUEST, saga.fetchTransactionFile);
    yield takeLatest(constants.DOWNLOAD_FILE_TRANSACTION.REQUEST, saga.downloadFile);
}